export default __webpack_public_path__ + "static/media/testnet.9f12d51e.svg";